let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bBLb1")).then(() => parcelRequire('5P2oX'));